exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".IA_VideoMainDiv_3z7S4bBm0l_yjKoy4E_mHM {\n  width: 100%;\n  height: 100%;\n  background-color: black;\n}\n\n.IA_VideoMainDiv_3z7S4bBm0l_yjKoy4E_mHM iframe {\n  margin: 0 !important;\n  height: 100%;\n}", ""]);

// Exports
exports.locals = {
	"IA_VideoMainDiv": "IA_VideoMainDiv_3z7S4bBm0l_yjKoy4E_mHM"
};